import { c as _c } from "react/compiler-runtime";
import { createContext, PropsWithChildren, RefObject, useContext, useMemo, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
interface AnonymousNewslettersContextShape {
  email: string;
  setEmail: (email: string) => void;
  isSubscribed: boolean;
  setIsSubscribed: (value: boolean) => void;
  recaptchaRef: RefObject<ReCAPTCHA | null>;
}

/**
 * Context for managing anonymous user state in newsletters page.
 * Handles email input, subscription status, and reCAPTCHA execution.
 */
const AnonymousNewslettersContext = createContext<AnonymousNewslettersContextShape>({
  email: "",
  setEmail: () => {},
  isSubscribed: false,
  setIsSubscribed: () => {},
  recaptchaRef: {
    current: null
  }
});
export const AnonymousNewslettersProvider = t0 => {
  "use memo";

  const $ = _c(6);
  const {
    children
  } = t0;
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const recaptchaRef = useRef(null);
  let t1;
  if ($[0] !== email || $[1] !== isSubscribed) {
    t1 = {
      email,
      setEmail,
      isSubscribed,
      setIsSubscribed,
      recaptchaRef
    };
    $[0] = email;
    $[1] = isSubscribed;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const contextValue = t1;
  let t2;
  if ($[3] !== children || $[4] !== contextValue) {
    t2 = <AnonymousNewslettersContext.Provider value={contextValue}>{children}</AnonymousNewslettersContext.Provider>;
    $[3] = children;
    $[4] = contextValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const useAnonymousNewslettersContext = () => useContext(AnonymousNewslettersContext);